var hs = hs || {};

hs.lazyLoad = function(param) {

  param = param || {};

  //入口
  this.container = param.container || ".lazyload";

  // 标签
  this.tiggerTags = param.tiggerTags || "img";

  this.tiggerTagsData = param.tiggerTagsData || 'data-img'

};

hs.lazyLoad.prototype.init = function(param) {
  var _this = this;
  $(window).on("scroll", function() {

    if (param) {
      clearTimeout(param);
    }
    param = setTimeout(function() {
      _this.checkShow();
    }, 200);

  });
  _this.checkShow();
};

// 计算可是区域滚动条方法
hs.lazyLoad.prototype.shouldShow = function($node) {

  var scrollHeight = $(window).scrollTop();
  var winHeight = $(window).height();
  var offsetTop = $node.offset().top;

  if (offsetTop < winHeight + scrollHeight) {
    return true;
  } else {
    return false;
  };

};

//图片替换
hs.lazyLoad.prototype.showImg = function($node) {
  var _this = this
  var $tiggerTagsData = this.tiggerTagsData;

  $node.attr('src', $node.attr($tiggerTagsData));
  $node.attr('isLoaded', true);
};

// 循环检测图片
hs.lazyLoad.prototype.checkShow = function() {

  var _this = this;

  var $container = $(_this.container);
  var $tiggerTags = $container.find(_this.tiggerTags);

  $($tiggerTags).each(function() {

    var $cur = $(this)

    if ($cur.attr('isLoaded')) {
      return;
    };

    if (_this.shouldShow($cur)) {
      _this.showImg($cur);
    };

  });

};